import React, { useCallback } from 'react';
import { Handle } from 'react-flow-renderer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import theme from '../theme';
import { useT } from '../i18n/langContext';

const CustomCardNode = ({ data, id }) => {
  const t = useT();
  // Double-click handler
  const handleDoubleClick = useCallback(() => {
    // Any card, used or not, can be flipped manually by the user.
    if (data.onCardNodeUpdate) {
      data.onCardNodeUpdate(id, { ...data, isFlipped: !data.isFlipped });
    }
  }, [data, id]);

  return (
    <div
      style={{
        textAlign: 'center', padding: '0', margin: '0', display: 'block', width: '200px', position: 'relative',
        borderLeft: data.phaseColor ? `4px solid ${data.phaseColor}` : 'none',
        borderRadius: data.phaseColor ? '8px' : 0,
      }}
      onDoubleClick={handleDoubleClick} // Ensure this is correctly set
    >
      {!data.isFlipped && data.descrizioneBreve && (
        <button
          type="button"
          title={t('canvas.cardNode.infoTooltip')}
          onClick={(e) => { e.stopPropagation(); data.onShowInfo && data.onShowInfo(data); }}
          style={{
            position: 'absolute', top: 6, right: 6, zIndex: 2,
            width: 22, height: 22, borderRadius: '50%', border: 'none',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            // Dashboard board tone (InfiniteCanvas.css --board-bg), not a
            // generic white chip — reads as part of the canvas chrome.
            background: '#F8F3EA', color: theme.home.cyanText,
            cursor: 'pointer', fontSize: 11,
            boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
          }}
        >
          <FontAwesomeIcon icon={faInfo} />
        </button>
      )}
      <img
        src={data.isFlipped ? data.backImage : data.image}
        alt={data.label}
        style={{
          width: '100%',
          height: 'auto',
          transition: 'transform 0.6s',
          transform: data.isFlipped ? 'rotateY(360deg)' : 'rotateY(0deg)',
          backfaceVisibility: 'hidden',
          borderRadius: '8px',
          // Barely-there — a tight contact shadow plus a soft wide ambient
          // one, both at low alpha, still reads as lifted off the canvas
          // without drawing attention to itself.
          boxShadow: '0 1px 2px rgba(0,0,0,0.06), 0 4px 10px rgba(0,0,0,0.05)',
        }}
      />
      <Handle
        id="a"
        type="source"
        position="top"
        style={{ background: '#afc2ae', left: '55%', width: '5px', height: '5px' }}
      />
      <Handle
        id="b"
        type="target"
        position="top"
        style={{ background: '#d3aaaa', left: '45%', width: '5px', height: '5px' }}
      />
      <Handle
        id="c"
        type="source"
        position="bottom"
        style={{ background: '#afc2ae', left: '55%', width: '5px', height: '5px' }}
      />
      <Handle
        id="d"
        type="target"
        position="bottom"
        style={{ background: '#d3aaaa', left: '45%', width: '5px', height: '5px' }}
      />
      <Handle
        id="e"
        type="source"
        position="left"
        style={{ background: '#afc2ae', top: '45%', width: '5px', height: '5px' }}
      />
      <Handle
        id="f"
        type="target"
        position="left"
        style={{ background: '#d3aaaa', top: '55%', width: '5px', height: '5px' }}
      />
      <Handle
        id="g"
        type="source"
        position="right"
        style={{ background: '#afc2ae', top: '45%', width: '5px', height: '5px' }}
      />
      <Handle
        id="h"
        type="target"
        position="right"
        style={{ background: '#d3aaaa', top: '55%', width: '5px', height: '5px' }}
      />
    </div>
  );
};

export default CustomCardNode;
